import { Component, ContentChildren, Input, QueryList } from '@angular/core';
import { CssMediaService } from '../../lib/media.service';

import { SeCheckedItemComponent } from './se-checkeditem.component';
import { NgClass, NgForOf, NgIf } from '@angular/common';

@Component({
    selector: 'se-checkedlistbox',
    templateUrl: './se-checkedlistbox.component.html',
    styleUrls: ['./se-checkedlistbox.component.css'],
    standalone: true,
    imports: [NgClass, NgForOf, NgIf],
})
export class SeCheckedListBoxComponent {
    // data members

    @Input()
    title: string;

    @Input()
    titleVisible = true;

    @Input()
    isVerticalOrientation = true;

    @ContentChildren(SeCheckedItemComponent)
    items: QueryList<SeCheckedItemComponent>;

    constructor(private cssMediaService: CssMediaService) {}

    private _selectedItem: SeCheckedItemComponent;

    get selectedItem() {
        return this._selectedItem;
    }

    // constructor

    set selectedItem(selectedItem: SeCheckedItemComponent) {
        this.activeItem(selectedItem);
    }

    // public functions

    activeItem(currentItem: SeCheckedItemComponent) {
        this._selectedItem = currentItem;
    }
}
